import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

import { Typography } from '../Typography/Typography';

export const Root = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 8px;
`;

const metaTextStyles = `
  margin-left: 12px;
  align-self: flex-start;
`;

export const BigLabel = styled.label`
  ${metaTextStyles};
  color: ${uiToken.color.text.primary};
`;

export const Label = styled.label`
  ${metaTextStyles};
  color: ${uiToken.color.text.secondary};
`;

export const Error = styled(Typography.H4)`
  ${metaTextStyles};
  color: ${uiToken.color.system.error};
`;

export const Description = styled(Typography.H4)`
  ${metaTextStyles};
  color: ${uiToken.color.text.secondary};
`;
